var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarningNoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10269 3.64316L1.44385 17.0469C0.171752 19.2713 1.77819 22.04 4.34111 22.04H19.6591C22.2209 22.04 23.8272 19.2716 22.5564 17.047L14.8975 3.64316C13.6167 1.39995 10.3835 1.39995 9.10269 3.64316ZM13.1607 4.63485L20.8199 18.0391C21.329 18.9305 20.6852 20.04 19.6591 20.04H4.34111C3.31404 20.04 2.67045 18.9308 3.18018 18.0394L10.8394 4.63512C11.3527 3.73606 12.6475 3.73606 13.1607 4.63485ZM12.0001 8.38C12.5129 8.38 12.9356 8.76604 12.9934 9.26338L13.0001 9.38V13.12C13.0001 13.6723 12.5524 14.12 12.0001 14.12C11.4873 14.12 11.0646 13.734 11.0068 13.2366L11.0001 13.12V9.38C11.0001 8.82772 11.4478 8.38 12.0001 8.38ZM11.9991 15.125L12.1269 15.1315C12.7575 15.1954 13.2501 15.7271 13.2501 16.375C13.2501 17.0653 12.6904 17.625 12.0001 17.625C11.3098 17.625 10.7501 17.0653 10.7501 16.3823C10.7454 15.7317 11.2388 15.1959 11.8709 15.1315L11.9991 15.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningNoColor);
export default __webpack_public_path__ + "static/media/icon-warning-no-color.3af03707bfc6b0431ebb284cd6d3557b.svg";
export { ForwardRef as ReactComponent };